import { useEffect, useState } from 'react';
import ExceptionConfigSection from './ExceptionConfigSection';
import { invoiceFieldCategories, invoiceFieldLabels, INVOICE_LAYOUTS } from '../constants';

const InvoiceExceptionsSection = (props: any) => {
  const { formState } = props;
  const [selectedLayout, setSelectedLayout] = useState('default');

  const handleLayoutChange = (layoutId: string) => {
    setSelectedLayout(layoutId);

    const base = INVOICE_LAYOUTS.default.fields;

    const extra = INVOICE_LAYOUTS[layoutId]?.fields ?? [];

    props.setFormState({
      layout: layoutId,
      fields: Array.from(new Set([...base, ...extra])),
    });
  };

  useEffect(() => {
    if (formState?.layout) {
      setSelectedLayout(props.formState.layout);
    }
  }, [props, formState?.layout]);

  return (
    <ExceptionConfigSection
      title="Invoice Detail Layouts"
      categories={invoiceFieldCategories}
      fieldLabels={invoiceFieldLabels}
      selectedLayout={selectedLayout}
      onLayoutChange={handleLayoutChange}
      isLayoutLocked={true}
      hideBulkActions={true}
      layoutOptions={Object.values(INVOICE_LAYOUTS)}
      {...props}
    />
  );
};

export default InvoiceExceptionsSection;
